import { useNavigate } from "react-router-dom";
import AuiButton from "../../components/Buttons/Buttons";
import "./PageNotFound.scss";
import { AdminRoles } from "../../utils/constants/app-constants";

const PageNotFound = () => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("role") ?? "";

  const onBackBtnHandle = () => {
    if (
      userRole === AdminRoles.SponsoringAdmin ||
      userRole === AdminRoles.MasterTrainer ||
      userRole === AdminRoles.ApprovingAdmin
    ) {
      navigate("/course-listing");
    } else if (userRole === AdminRoles.SuperAdmin) {
      navigate("/organization-listing");
    }
  };

  return (
    <div className="page-404">
      <div className="container">
        <div className="w-100">
          <aui-globalerror
            pageerror={404}
            errortype="secondary"
            heading="Oops! Page does not exist."
          >
            <p className="aui-not-found-subtitle pb-3">
              The page you are looking for cannot be found . Either the URL is
              incorrect, or the page has been removed.{" "}
            </p>
            <h6 className="pb-3">
              We suggest you to start all over again in the main section
            </h6>
            <AuiButton
              onClick={onBackBtnHandle}
              className="mt-6 px-6 py-2 text-white bg-red-600 rounded-lg hover:bg-red-700 transition"
              variant="primary"
              buttontitle="Return to home page"
              buttonid={""}
            ></AuiButton>
          </aui-globalerror>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
